<template>
    <div>
        <TableList
            :form_data_seo.sync="form_data_seo"
            :columns="columns"
            :get_table_list="this.get_table_list"
            :submit_preprocessing="submit_preprocessing"
            :slot_table_list="['operation']"
            ref="list"
			:is_created_get_list="false"
        >
            <template slot="right_btn">
                <a v-if="this.$store.state.page_auth.export" @click="report()">
					<a-button class="a_btn">导出</a-button>
				</a>
            </template>
            <template slot="operation" slot-scope="data">
                <span v-auth="'change'">
                    <a @click="editPut(data.record)">编辑</a>
                </span>
                <a-divider v-auth="'change'" type="vertical" />
                <span>
                    <a @click="details(data.record)">查看</a>
                </span>
            </template>
        </TableList>
    </div>
</template>

<script>
// @ is an alias to /src
import EditPop from "@/components/EditPop";
import Form from "@/components/Form";
import TableList from "@/components/TableList";
import { costGrantList ,getCostType} from "@/api/cost";
import { getType } from '@/api/approval'
let columns = [
    {
        title: "投放周",
        dataIndex: "week",
    },
    {
        title: "申请人",
        dataIndex: "username",
    },
    {
        title: "部门",
        dataIndex: "path_name",
    },
    {
        title: "发放客户ID",
        dataIndex: "customer_id",
    },
    {
        title: "客户名称",
        dataIndex: "customer_name",
    },
    {
        title: "投放类型",
        dataIndex: "launch_type",
    },

    {
        title: "投放位置",
        dataIndex: "launch_position",
    },
    {
        title: "审批状态",
        dataIndex: "approval_status_name",
    },
    {
        title: "事由",
        dataIndex: "desc",
    },
    {
        title: "配送人",
        dataIndex: "give_user",
    },
    {
        title: "签收状态",
        dataIndex: "settle_status",
    },
    {
        title: "操作",
        scopedSlots: {
            customRender: "operation"
        }
    },
];

export default {
    name: "IndexGrant",
    components: {
        EditPop,
        Form,
        TableList
    },
    data() {
        return {
            get_table_list: costGrantList,
            submit_preprocessing: {
                array_to_string: ['department_id','type_id']
            },
            columns,
            form_data_seo: {
                list: [
                    {
                        type: "tree-select",
                        name: "department_id",
                        title: "部门",
                        options: {},
                        treeData: [],
                        multiple: true
                    },
                    {
                        type: "tree-select",
                        name: "type_id",
                        title: "投放类型",
                        options: {},
                        treeData: [],
                        multiple: true
                    },
                    // {
                    //     type: "select",
                    //     name: "type_id",
                    //     title: "投放类型",
                    //     list: [],
                    //     options: {

                    //     }
                    // },
                    {
                        type: "text",
                        name: "customer",
                        title: "发放客户",
                        placeholder: '输入客户名称、ID、地址',
                        options: {

                        }
                    },
                    {
                        type: "text",
                        name: "username",
                        title: "申请人",
                        placeholder: '输入工号、姓名、手机号',
                        options: {

                        }
                    },
                    /* {
                        type: "range_date",
                        name: "range_date",
                        title: "创建时间",
                        options: {},
                        start: {
                            name: 'start_time'
                        },
                        end: {
                            name: 'end_time'
                        },
                    }, */
                    // {
                    //     type: 'select',
                    //     name: 'status',
                    //     title: '审批状态',
                    //     list: [
                    //         ...this.$config.status_all,
                    //         ...this.$config.approval_status_list
                    //     ],
                    //     options: {},
                    // },
                    // {
                    //     type: 'select',
                    //     name: 'customer_write',
                    //     title: '签收状态',
                    //     list: [
                    //         {
                    //             key:0,
                    //             value:'未签收'
                    //         },
                    //         {
                    //             key:1,
                    //             value:'已签收'
                    //         },
                    //         {
                    //             key:2,
                    //             value:'异常签收'
                    //         }
                    //     ],
                    //     options: {},
                    // },
					{
						type: 'month',
						name: 'grant_time',
						title: '发放时间',
						
						options: {
							initialValue:''
						}
					},
                ],
                ...this.$config.form_data_seo
            },

        };
    },
    async created() {
		// 缓存该页面
        this.$method.get_department().then(res => {
            this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'department_id', 'treeData', res)
        });
       
		  this.form_data_seo.list.forEach(it=>{
			  if(it.name=='grant_time'){
				  it.options.initialValue = this.$moment(new Date()).format('YYYY-MM')
			  }
		  })
        getCostType().then(res => {
            this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'type_id', 'treeData', res.data.list)
        })
		let query = this.$route.query;
		this.$nextTick(() => {
            this.$refs.list.fixed_seo_data = {
                ...query,
					grant_time: this.$moment(new Date()).format('YYYY-MM')
            }
            this.$refs.list.get_list();
        })
    },
    methods: {
        details(data) {
			this.$keep_route.add(this.$options.name);
            if (data.id) {
                this.$router.push('put_detail?id=' + data.id + '&grant_id=' + data.approval_id)
            }
        },
		report() {
			this.$keep_route.add(this.$options.name);
			this.$router.push({
				path:"/report/modify_report",
				query:{
					report_key:"custom_cost_grant",
					...this.$refs.list.seo_data
				}
			});
		},
        editPut(data) {
			this.$keep_route.add(this.$options.name);
            this.$router.push({
                path:"./grant_edit",
                query:{
                    id:data.grant_id
                }
            })
        }
    }
};
</script>

<style lang="less">
@import url("../../assets/less/app.less");
</style>